import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
function FadeInUp({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.7,
    delay
  }} data-id="element-87">
      {children}
    </motion.div>;
}
type FAQItemProps = {
  question: string;
  answer: string;
  index: number;
};
function FAQItem({
  question,
  answer,
  index
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeInUp delay={index * 0.1} data-id="element-88">
      <div className="rounded-xl overflow-hidden" style={{
      background: 'rgba(15, 31, 61, 0.7)',
      border: `1px solid ${isOpen ? 'rgba(201, 168, 76, 0.4)' : 'rgba(201, 168, 76, 0.15)'}`,
      transition: 'border-color 0.3s ease'
    }} data-id="element-89">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left" aria-expanded={isOpen} data-id="element-90">
          <span className="font-heading font-600 text-lg pr-4" style={{
          color: isOpen ? 'var(--color-gold)' : 'var(--color-cream)'
        }} data-id="element-91">
            {question}
          </span>
          <motion.span animate={{
          rotate: isOpen ? 45 : 0
        }} transition={{
          duration: 0.3
        }} className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-body font-700 text-xl" style={{
          background: isOpen ? 'rgba(201, 168, 76, 0.15)' : 'rgba(201, 168, 76, 0.08)',
          color: 'var(--color-gold)',
          border: '1px solid rgba(201, 168, 76, 0.3)'
        }} data-id="element-92">
            +
          </motion.span>
        </button>
        <AnimatePresence data-id="element-93">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="overflow-hidden" data-id="element-94">
              <div className="px-6 pb-6" data-id="element-95">
                <div className="h-px mb-4" style={{
              background: 'rgba(201, 168, 76, 0.15)'
            }} data-id="element-96" />
                <p className="font-body text-base leading-relaxed" style={{
              color: 'var(--color-cream-dim)'
            }} data-id="element-97">
                  {answer}
                </p>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeInUp>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Es difícil de seguir?',
    answer: 'No, se basa en alimentos que ya conoces. Solo reorganizamos cuándo y cómo los comes. No necesitas cocinar recetas complicadas ni comprar ingredientes exóticos. Si puedes ir al supermercado, puedes seguir este protocolo.'
  }, {
    question: '¿Debo dejar mis medicinas?',
    answer: 'Nunca. Este plan complementa tu tratamiento médico y suele ayudar a que tu médico reduzca tus dosis gradualmente. Siempre consulta con tu médico antes de hacer cambios en tu medicación.'
  }, {
    question: '¿Es caro?',
    answer: 'Al contrario, ahorrarás dinero al dejar de comprar productos procesados y suplementos innecesarios. La mayoría de los alimentos del protocolo son económicos y fáciles de encontrar en cualquier supermercado.'
  }, {
    question: '¿Funciona para personas mayores de 70 años?',
    answer: 'Sí. El protocolo está diseñado específicamente para cuerpos maduros. Las tres fases respetan los ritmos biológicos de personas de 55 años en adelante, incluyendo quienes tienen más de 70.'
  }, {
    question: '¿Cuándo recibiré el material?',
    answer: 'Inmediatamente después del pago. Recibirás un correo electrónico con acceso instantáneo a todos los materiales digitales. No hay espera, no hay envío físico.'
  }];
  return <section className="w-full py-20 px-4" style={{
    background: 'linear-gradient(180deg, #0a1628 0%, #0d1a2e 100%)'
  }} data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <FadeInUp data-id="element-100">
          <div className="text-center mb-12" data-id="element-101">
            <div className="section-divider mb-6" data-id="element-102">
              <span className="ornament" data-id="element-103">?</span>
            </div>
            <h2 className="font-heading font-700 text-4xl md:text-5xl mb-4" style={{
            color: 'var(--color-cream)'
          }} data-id="element-104">
              Preguntas
              <span className="block italic" style={{
              color: 'var(--color-gold)'
            }} data-id="element-105">
                Frecuentes
              </span>
            </h2>
          </div>
        </FadeInUp>

        <div className="space-y-4" data-id="element-106">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.question} answer={faq.answer} index={i} data-id="element-107" />)}
        </div>
      </div>
    </section>;
}